import { ToastContainer } from 'react-toastify';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import BR from 'antd/es/locale/pt_BR';

import Root from './pages';
import GlobalStyle from './styles/global';
import AppProvider from './hooks';

import 'react-toastify/dist/ReactToastify.min.css';
import 'antd/dist/antd.css';

function App() {


  return (
    <ConfigProvider locale={BR}>
      <AppProvider>
        <Router basename="web/ssa">

          <Root />
          <GlobalStyle />
          <ToastContainer autoClose={3000} />
        </ Router>
      </AppProvider>
    </ConfigProvider>
  );
}

export default App;
